<p-dialog
  [(visible)]="visible"
  [modal]="true"
  header="header"
  [closable]="false"
  [closeOnEscape]="true"
  [style]="{ minWidth: '25rem', width: '30%' }"
  (onHide)="onDialogHide()"
>
  <ng-template pTemplate="header">
    <div class="title">
      {{ title() | translate: titleParams() }}
    </div>
  </ng-template>

  <p class="message" [innerHTML]="message() | translate: messageParams()"></p>

  <p-divider />

  <div class="footer-buttons pt-3">
    <op-button-ng
      *ngFor="let btn of buttons()"
      (click)="onButtonClick(btn.response)"
      [label]="btn.label | translate"
      [color]="buttonColor(btn.label)"
      [outlined]="true"
      size="medium"
    />
  </div>
</p-dialog>
